<template>
  <div class="mb-3">
    <h3>同期設定</h3>
    <v-row class="mt-3">
      <v-alert class="col-12" border="left" colored-border type="warning">
        メールマガジン配信を許可している会員情報を（午前0時）にメールマガジン配信サービスに自動同期されます。
      </v-alert>
      <v-checkbox
        class="col-3"
        label="自動同期する"
        v-model="formValue.isAutoSync"
      ></v-checkbox>
      <v-btn
        class="col-1 ml-auto"
        color="green darken-1"
        tile
        dark
        depressed
        @click="updateSyncSetting"
      >
        更新
      </v-btn>
    </v-row>
  </div>
</template>

<script>
import { patch } from 'axios'
import { deserialize } from 'deserialize-json-api'

export default {
  name: 'SyncSettingsFormContainer',
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      formValue: {
        isAutoSync: false
      }
    }
  },
  watch: {
    value (newValue) {
      this.formValue = { ...this.formValue, ...newValue }
    }
  },
  methods: {
    updateSyncSetting () {
      this.$store.dispatch('LoaderStore/displayLoader')
      const params = {
        mailMagazineSyncSetting: this.formValue
      }
      patch(
        `/api/mail_magazine_sync_settings/${this.$route.params.service}`,
        params
      )
        .then(({ data }) => {
          this.$emit('input', deserialize(data).data)
          const payload = {
            status: 200,
            message: '同期設定を更新しました。'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        })
        .catch((error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.message
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        })
        .finally(() => {
          this.$store.dispatch('LoaderStore/hideLoader')
        })
    }
  }
}
</script>
